import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import NoteAltIcon from '@mui/icons-material/NoteAlt';

import MemoEditDialog from './MemoEditDialog.js'
import { fetchMemos } from './memoApi.js'

// タイトルバーに置くメモ追加アイコン（件数バッジ付き）。クリックで追加ダイアログを直接開く
// メモの一覧は画面側の MemoSection で表示し、保存後は onSaved で再読み込みしてもらう
// 対象の指定方法は MemoSection と同じ（personalCode または workplaceInstitutionCode）
export default function MemoAddIconButton(props) {
  const { token, personalCode, workplaceInstitutionCode, targetLabel, hospitalOptions, reloadKey, onSaved } = props;

  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);

  const loadCount = useCallback(() => {
    const params = personalCode
      ? { personal_code: personalCode }
      : { workplace_institution_code: workplaceInstitutionCode };

    fetchMemos(token, params)
      .then((response) => setCount(response.data.count))
      .catch(() => setCount(0));
  }, [token, personalCode, workplaceInstitutionCode]);

  // reloadKey: 画面側でメモを編集・削除したときに件数を取り直す
  useEffect(() => {
    loadCount();
  }, [loadCount, reloadKey]);

  const handleClose = (saved) => {
    setOpen(false);
    if (saved) {
      // onSaved で画面側が reloadKey を更新すれば件数もそこで取り直される
      if (onSaved) {
        onSaved();
      } else {
        loadCount();
      }
    }
  };

  return (
    <>
      <Tooltip title="メモを追加">
        <IconButton color="inherit" aria-label="メモを追加" onClick={() => setOpen(true)}>
          <Badge badgeContent={count} color="error">
            <NoteAltIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <MemoEditDialog
        open={open}
        onClose={handleClose}
        token={token}
        personalCode={personalCode}
        workplaceInstitutionCode={workplaceInstitutionCode}
        targetLabel={targetLabel}
        hospitalOptions={hospitalOptions}
      />
    </>
  );
}

MemoAddIconButton.propTypes = {
  token: PropTypes.string.isRequired,
  personalCode: PropTypes.string,
  workplaceInstitutionCode: PropTypes.string,
  targetLabel: PropTypes.string,
  hospitalOptions: PropTypes.array,
  reloadKey: PropTypes.number,
  onSaved: PropTypes.func,
};
